<template>
    <div class="modal">
        <div class="register">
            <div class="head">
                <span class="title">用戶註冊</span>
                <div class="close" @click="onClose">
                    <a-icon type="close" style="color: #fff;" />
                </div>
            </div>
            <div class="register-form">
                <div class="logos">
                    <img :src="association && association.logourl" alt="">
                    <img src="../../assets/imgs/img_logo.png" alt="">
                </div>
                <div class="form-item head">
                    <span>服務由</span>
                    <a href="http://www.ectcm.com" target="_blank">中醫在綫</a>
                    <span>提供，學會會員和中醫在綫網通用。</span>
                </div>
                <div class="form-item">
                    <span class="hint">中文姓名:</span>
                    <input type="text" class="value" placeholder="请输入中文姓名" v-model="clientname">
                </div>
                <div class="form-item">
                    <span class="hint">性  别:</span>
                    <select :class="{'value': true, 'placeholder': !clientSex }" v-model="clientSex">
                        <option value="">请选择性别</option>
                        <option value="1">男</option>
                        <option value="2">女</option>
                    </select>
                </div>
                <div class="form-item">
                    <span class="hint">手機號:</span>
                    <input type="tel" class="value" placeholder="请输入註冊手機號" v-model="phone">
                </div>
                <div class="form-item">
                    <span class="hint">密　碼:</span>
                    <input type="password" class="value" placeholder="请输入賬號密碼" v-model="password">
                </div>
                <div class="form-item">
                    <span class="hint">驗證碼:</span>
                    <input type="number" class="value" placeholder="请输入短信驗證碼" v-model="phoneCode">
                    <button class="btn-code" @click="getPhoneCode" v-text="phoneCodeText"></button>
                </div>
                <div class="options">
                    <button class="btn-register" @click="register">註冊</button>
                    <a href="javascript:;" @click="login">登录</a>
                </div>
                <loading v-if="loading" />
            </div>
        </div>
    </div>
</template>

<script>
    import Loading from '../Loading.vue'
    export default {
        components: { Loading },
        props: {
            callback: Function,
        },
        data(){
            return {
                loading: false,
                clientname: '',
                clientSex: '',
                phone: '',
                password: '',
                phoneCode: '',
                codeKey: '',
                phoneCodeText: '獲取驗證碼',
                association: this.$store.getters.association,
                time: 0,
            }
        },
        mounted: function(){
        },
        methods: {
            getPhoneCode: function(){
                if(this.time) return
                if(!/^1[3-9]{1}[0-9]{9}$/.test(this.phone.trim()) && !/^([5|6|8|9])\d{7}$/.test(this.phone.trim())) {
                    this.$message.warning('請輸入正確的手機號')
                    return
                }
                this.$store.dispatch('getVCode', {codeType: 2, phoneNumber: this.phone}).then((rs) => {
                    this.codeKey = rs.codeKey
                    this.$message.success('驗證碼已發送')
                    this.time = 60
                    this.phoneCodeText = `${this.time}s`
                    setTimeout(() => {
                        this.runTimer()    
                    }, 1000)
                })
            },
            runTimer: function(){
                this.time = this.time-1
                if(this.time == 0) {
                    this.phoneCodeText = '獲取驗證碼'
                    return
                }
                this.phoneCodeText = `${this.time}s`
                setTimeout(() => {
                    this.runTimer()
                }, 1000);
            },
            onClose: function(){
                this.callback && this.callback()
            },
            login: function(){
                this.callback && this.callback('login')
            },
            register: function(){
                if(!this.clientname || ! this.clientname.trim()) {
                    this.$message.warning('請輸入中文姓名')
                    return
                }
                if(!this.clientSex || ! this.clientSex.trim()) {
                    this.$message.warning('請選擇性別')
                    return
                }
                if(!this.phone || ! this.phone.trim()) {
                    this.$message.warning('請輸入手機號')
                    return
                }
                if(!/^1[3-9]{1}[0-9]{9}$/.test(this.phone.trim()) && !/^([5|6|8|9])\d{7}$/.test(this.phone.trim())) {
                    this.$message.warning('請輸入正確的手機號')
                    return
                }
                if(!this.password || !this.password.trim()) {
                    this.$message.warning('請輸入賬號密碼')
                    return
                }
                if(!this.phoneCode || !this.phoneCode.trim()) {
                    this.$message.warning('請輸入短信驗證碼')
                    return
                }
                if(!this.codeKey) {
                    this.$message.warning('短信驗證碼输入不正确')
                    return
                }
                this.loading = true
                var params = {
                    clientName: this.clientName,
                    codeKey: this.codeKey,
                    confirmPassword: this.password,
                    password: this.password,
                    phoneCode: this.phoneCode,
                    phoneNumber: this.phone.trim(),
                    signedPrivacy: true,
                    sourceType: 'F',
                    clientSex: this.clientSex
                }
                this.$store.dispatch('register', params).then((rs) => {
                    this.loading = false
                    this.callback && this.callback('registerSuccess')
                    this.$message.success('註冊成功!')
                }).catch((error) => {
					this.loading = false
					this.$message.warning(error || '登錄失敗, 請稍後重試！')
                })
                
            }
        },
        created: function(){
            setTimeout(() => {
                document.body.style="overflow: hidden;"
            }, 50)
        },
        destroyed: function(){
          document.body.style="overflow: unset;"
        }
    }
</script>

<style scoped>
    .modal {
        position: fixed;
        background-color: #73737347;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        z-index: 99;
    }

    .register {
        border-radius: 8px;
        box-shadow: 0 5px 15px rgba(0, 50, 0, .4);
        -moz-transition: -moz-box-shadow linear .2s;
        -webkit-transition: -webkit-box-shadow linear .2s;
        transition: -webkit-box-shadow linear .2s;
        position: absolute;
        left: 50%;
        top: 50%;
        width: 400px;
        height: 460px;
        background-color: #fff;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
    }

    .register > .head {
        height: 33px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        background-image: linear-gradient(235deg,#7cc661,#3f9528);
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        padding: 0 12px;
    }

    .register > .head > .title {
        height: 29px;
        line-height: 29px;
        padding: 0 25px 0 0;
        text-indent: 5px;
        color: #FFF;
        font-size: 16px;
        font-weight: 700;
        text-shadow: -1px -1px 0 rgba(0, 50, 0, .7);
    }

    .register > .head > .close {
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }

    .register > .register-form {
        flex: 1;
        display: flex;
        flex-direction: column;
        padding: 0px 24px;
        position: relative;
    }

    .register > .register-form > .logos {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        margin: 12px 0;
    }

    .register > .register-form > .logos > img {
        width: 180px;
        height: 30px;
        object-fit: contain;
        border: 1px solid #f7f7f7;
        
    }

    .register > .register-form > .form-item {
        display: flex;
        flex-direction: row;
        height: 33px;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 16px;
        color: #232323;
        font-weight: 400;
        font-size: 14px;
        position: relative;
    }

    .register > .register-form > .form-item > .btn-code {
        position: absolute;
        right: 8px;
        height: 28px;
        line-height: 28px;
        width: 90px;
        background-color: #e7e7e7;
        border-radius: 2px;
    }

    .register > .register-form > .form-item > .btn-code:active {
        opacity: 0.7;
    }

    .register > .register-form > .form-item > a {
        color: #3f9528;
        text-decoration: underline;
    }

    .register > .register-form > .form-item > .hint {
        color: #232323;
        font-size: 16px;
        font-weight: 400;
        padding-left: 12px;
        position: relative;
    }

    .register > .register-form > .form-item > .hint::before {
        content: '*';
        position: absolute;
        left: 2px;
        top: 2px;
        color: #f00;
    }

    .register > .register-form > .form-item > .value {
        display: block;
        flex: 1;
        height: 33px;
        line-height: 33px;
        border: 1px solid #e8e8e8;
        border-radius: 2px;
        padding: 0 8px;
        margin-left: 12px;
        font-size: 16px;
        color: #232323;
        font-weight: 400;
    }

    .register > .register-form > .form-item > .value::placeholder,
    .register > .register-form > .form-item > .value.placeholder {
        color: #999;
        font-size: 15px;
        font-weight: 400;
    }

    .register > .register-form > .options {
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin-top: 20px;
        align-items: center;
    }

    .register > .register-form > .options > .btn-register {
        height: 33px;
        line-height: 33px;
        padding: 0 35px;
        color: #fff;
        border-radius: 8px;
        background-color: #3f9528;
        border: 1px solid #ddd;
        box-shadow: 1px 1px 5px #eee;
    }

    .register > .register-form > .options > .btn-register:active {
        opacity: 0.7;
    }

    .register > .register-form > .options > a {
        color:#3f9528;
        text-decoration: underline;
        margin-left: 40px;
    }

    @media only screen and (max-width: 1050px) {
        .register {
            width: 95%;
        }

        .register > .register-form > .form-item.head {
            height: unset;
            display: block;
        }
    }
</style>
